import React from 'react';
import {
	func,
	array,
	number,
	bool
} from 'prop-types';
import style from './style';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

const maxScoreCount = 3;

const Presenter = ({ scores, showMoreScore, onToggleShowMore, average, t }) => {
	if(scores.length===0) {
		return (
			<style.NoScore>{t('recipe-detail.NoScore')}</style.NoScore>
		);
	}
	return (
		<style.Wrapper>
			<ResponsiveContainer width="95%" height={400}>
				<LineChart data={scores.slice().reverse()}>
					<Line type="monotone" dataKey="percentScore" stroke="#8884d8" />
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="localeDateTime" />
					<YAxis type="number" domain={[0, 100]}/>
					<Tooltip/>
				</LineChart>
			</ResponsiveContainer>
			
			<style.Scores>
				<style.ScoreTable>
					<table>
						<thead>
							<tr>
								<th>{t('home.LastExecution')}</th>
								<th>{t('home.Score')}</th>
							</tr>
						</thead>
						<tbody>
							{scores.filter((_,idx)=>showMoreScore||idx<maxScoreCount).map(score=>{
								return (
									<tr key={score.date}>
										<td>{score.dateTime.toLocaleString()}</td>
										<td>
											<style.ScoreColor avg={score.normalizedScore}>{score.percentScore}
											</style.ScoreColor>
										</td>
									</tr>);
							} )}
						</tbody>
					</table>
				</style.ScoreTable>
				
				<style.ShowMoreScore>
					<style.ShowMoreButton onClick={onToggleShowMore(!showMoreScore)}>
						{maxScoreCount < scores.length && 
                                (showMoreScore?(
                                	<span><style.ChevronUpIcon /> Less</span>
                                ):(
                                	<span><style.ChevronDownIcon /> Show more</span>
                                ))}
					</style.ShowMoreButton>
				</style.ShowMoreScore>
				<style.AvgScores>
					{t('recipe-detail.AverageScore')} : 
					<style.ScoreColor avg={average}>{average.toFixed(2)}</style.ScoreColor>
					( % )
				</style.AvgScores>
			</style.Scores>
		</style.Wrapper>
	);
};


Presenter.propTypes = {
	scores : array.isRequired,
	showMoreScore : bool,
	onToggleShowMore : func.isRequired,
	scoreCount : number.isRequired,
	average : number.isRequired,
	t : func.isRequired
};

export default withNamespaces()(Presenter);